import React, { useEffect, useRef } from "react";
import styled from "styled-components";


const SelectWrapper = styled.div`
    position: relative;
    display: inline-block;
    margin: 0 8px;
    --caret-reserve: 36px;

    &::after {
        content: '▼'; /* Unicode character for the caret */
        color: #f37c3e;
        font-size: 10px;
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none; /* Prevent the caret from blocking clicks */
    }
`;


const StyledSelect = styled.select`
    font-family: 'Inconsolata';
    appearance: none;
    background: none;
    border: none;
    border-bottom: 3px solid #f37c3e;
    padding-right: var(--caret-reserve); /* Reserve enough caret space for Firefox and Chrome */
    padding-bottom: 1px;
    cursor: pointer;
    font-size: 32px; /* Adjust the font size as needed */
    color: inherit; /* Inherit the text color */
    line-height: 1;

    /* Remove the default dropdown arrow */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    /* Position the select element relative to the custom caret */
    position: relative;
    display: inline-block;
`;


const HiddenSpan = styled.span`
    font-family: 'Inconsolata';
    font-size: 32px; /* Match the font size of the select element */
    visibility: hidden; /* Hide the span element */
    white-space: nowrap; /* Prevent text from wrapping */
    position: absolute; /* Remove from document flow */
`;


function GraphOption(props) {
    const selectRef = useRef(null);
    const spanRef = useRef(null);

    const handleChange = event => {
        props.setter(event.target.value);
    }

    useEffect(() => {
        const updateSelectWidth = () => {
            if (selectRef.current && spanRef.current) {
                spanRef.current.textContent = selectRef.current.options[selectRef.current.selectedIndex].text;
                selectRef.current.style.width = `${spanRef.current.offsetWidth + 44}px`;
            }
        };

        updateSelectWidth();
        window.addEventListener('resize', updateSelectWidth);

        return () => {
            window.removeEventListener('resize', updateSelectWidth);
        };

    }, [props.selected]);
    var options = [];
    for (const [key, value] of Object.entries(props.options)) {
        let option;
        if (value === null) {
            option = <option key={key} disabled style={{textAlign: 'center'}}>── {key} ──</option>
        } else {
            option = <option key={value} value={value}>{String(value).toLowerCase()}</option>
        }
        options.push(option);
    }

    return (
        <SelectWrapper>
            <StyledSelect ref={selectRef} defaultValue={props.selected} name={props.name} onChange={handleChange}>
                {options}
            </StyledSelect>
            <HiddenSpan ref={spanRef} />
        </SelectWrapper>
    );
}

export default GraphOption;
